import { openContextModal } from "@mantine/modals";
import { exitFullscreen } from "@shared/lib/Utils.ts";
import { ModalInnerProps } from "@shared/ui/Modal/IframeModal.tsx";

export const openIframeModal = (params: ModalInnerProps & { onClose?: () => void }) => {
	const { onClose, ...innerProps } = params;

	void exitFullscreen();

	openContextModal({
		modal: "iframe",
		modalId: "iframe",
		innerProps,
		fullScreen: innerProps.fullScreen,
		onClose,
		// Проп 'styles' теперь должен быть объектом.
		// Доступ к значениям темы, таким как отступы, осуществляется через CSS-переменные.
		styles: {
			header: {
				// Условие сохраняется, но в качестве значения используется CSS-переменная
				marginBottom: innerProps.fullScreen ? "var(--mantine-spacing-xs)" : undefined,

				// Математические операции с отступами темы переносятся в CSS-функцию calc()
				marginTop: innerProps.fullScreen
					? "calc(var(--mantine-spacing-lg) * -1 + var(--mantine-spacing-xs))"
					: undefined
			}
		}
	});
};
